export enum DragType {
    Container = "CONTAINER",
    Cell = "CELL",
}
